export const DOWNLOAD_FILE_REQUEST = 'DOWNLOAD_FILE_REQUEST';

export const downloadFileRequest = ( guid ) => ({
    type: DOWNLOAD_FILE_REQUEST,
    payload: { guid }
});
